import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Icon from "@mui/material/Icon";
import IconButton from "@mui/material/IconButton";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftButton from "components/SoftButton";
import { ThemedTrashIcon } from "assets/CXFIcons/Triggers";
import { ThemedXIcon } from "assets/CXFIcons/Static";
import PropTypes from "prop-types";
import useThemeDetector from "hooks/useThemeDetector";

export const DeleteRoleDialog = ({ open, onClose, onAccept, isRoleUsed }) => {
  const { isDarkMode } = useThemeDetector();

  return (
    <Dialog open={open} onClose={onClose} fullWidth={true} maxWidth="sm">
      <DialogTitle
        sx={{
          marginBottom: "20px",
          padding: "32px 24px 0 24px !important",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
        className="white-to-dark"
        data-testid="form-title"
      >
        <SoftBox display="flex" alignItems="center">
          <ThemedTrashIcon sx={{ fontSize: "16px !important", marginRight: "16px" }} />
          Delete Role
        </SoftBox>
        <IconButton
          onClick={onClose}
          size="small"
          aria-label="close dialog"
          sx={{
            zIndex: 1,
          }}
        >
          <ThemedXIcon style={{ color: isDarkMode ? "white" : "black" }} />
        </IconButton>
      </DialogTitle>
      <DialogContent
        sx={{
          padding: "0 32px 24px",
        }}
      >
        <SoftBox
          className="border-top"
          sx={{
            paddingTop: "20px",
          }}
        >
          {isRoleUsed && (
            <SoftBox
              sx={{
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: "#FFEDED",
                border: "1px solid #E53E3E",
                display: "flex",
                borderRadius: "9px",
                color: "#E53E3E",
                padding: "16px",
                marginBottom: "20px",
              }}
            >
              <Icon sx={{ fontSize: "16px !important", marginRight: "16px" }}>warning_amber</Icon>
              <SoftTypography
                sx={{
                  color: "#E53E3E",
                  fontSize: "14px",
                  fontWeight: 600,
                }}
              >
                Warning: This role is actively being used
              </SoftTypography>
            </SoftBox>
          )}
          <SoftTypography
            color="text"
            sx={{
              fontSize: "14px",
              marginBottom: "16px",
              textAlign: isRoleUsed ? "left" : "left",
            }}
          >
            {isRoleUsed
              ? "Deleting this role will remove the role from all associated users."
              : "Are you sure you want to delete this role?"}
          </SoftTypography>
          <SoftButton
            sx={{
              width: "100%",
            }}
            variant="outlined"
            color={isRoleUsed ? "secondary" : "error"}
            onClick={onAccept}
          >
            DELETE
          </SoftButton>
        </SoftBox>
      </DialogContent>
    </Dialog>
  );
};

DeleteRoleDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onAccept: PropTypes.func.isRequired,
  isRoleUsed: PropTypes.bool,
};

DeleteRoleDialog.defaultProps = {
  isRoleUsed: false,
};
